<template>
    <div>
        <v-text-field
            v-bind:label="$t('Profile')"
            v-model="digitalSignature.profile"
            :error-messages="profileErrors"
            @input="validation.profile.$touch()"
            @blur="validation.profile.$touch()"
        ></v-text-field>
        <v-text-field
            v-bind:label="$t('ClientId')"
            v-model="digitalSignature.clientId"
            :error-messages="clientIdErrors"
            @input="validation.clientId.$touch()"
            @blur="validation.clientId.$touch()"
        ></v-text-field>
        <v-text-field
            v-bind:label="$t('PIN')"
            v-model="digitalSignature.pinNumber"
            :error-messages="pinNumberErrors"
            @input="validation.pinNumber.$touch()"
            @blur="validation.pinNumber.$touch()"
        ></v-text-field>
        <v-text-field
            v-bind:label="$t('Login')"
            v-model="digitalSignature.login"
            :error-messages="loginErrors"
            @input="validation.login.$touch()"
            @blur="validation.login.$touch()"
            autocomplete="off"
            name="quovadis-login"
            id="quovadis-login"
        ></v-text-field>
        <v-text-field
            v-bind:label="$t('Password')"
            type="password"
            v-model="digitalSignature.password"
            :error-messages="passwordErrors"
            @input="validation.password.$touch()"
            @blur="validation.password.$touch()"
            autocomplete="new-password"
            name="quovadis-password"
            id="quovadis-password"
        ></v-text-field>
    </div>
</template>
<script>
export default {
    name: 'ConfigQuoVadisSignatureForm',
    props: {
        digitalSignature: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        profileErrors: {
            type: Array,
            default: () => []
        },
        clientIdErrors: {
            type: Array,
            default: () => []
        },
        pinNumberErrors: {
            type: Array,
            default: () => []
        },
        loginErrors: {
            type: Array,
            default: () => []
        },
        passwordErrors: {
            type: Array,
            default: () => []
        }
    },
};
</script>
